'use client';

import React, { createContext, useContext, useState } from 'react';
import { getContainer } from '@framework/di/getContainer';

const useAccessRestrictedByIp = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataroomName, setDataroomName] = useState('');
  const [restrictedIp, setRestrictedIp] = useState('');
  const [countryId, setCountryId] = useState('');

  const showAccessRestrictedByIpModal = (
    dataroomName: string,
    restrictedIp?: string,
    countryId?: string,
  ) => {
    setIsModalVisible(true);
    !!dataroomName && setDataroomName(dataroomName);
    !!restrictedIp && setRestrictedIp(restrictedIp);
    !!countryId && setCountryId(countryId);
  };

  const hideAccessRestrictedByIpModal = () => {
    setIsModalVisible(false);
  };

  return {
    countryId,
    restrictedIp,
    dataroomName,
    isModalVisible,
    showAccessRestrictedByIpModal,
    hideAccessRestrictedByIpModal,
  };
};

export type AccessRestrictedByIpContextType = ReturnType<typeof useAccessRestrictedByIp>;

const AccessRestrictedByIpContext = createContext<AccessRestrictedByIpContextType | null>(null);
export const AccessRestrictedByIpContextSymbol = Symbol('AccessRestrictedByIpContext');

export const useAccessRestrictedByIpContext = () => {
  const context = useContext(AccessRestrictedByIpContext);
  if (!context) {
    throw new Error('useAccessRestrictedByIpContext must be used within a AccessRestrictedByIpContextProvider');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
}

const AccessRestrictedByIpContextProvider = ({ children }: IProps) => {
  const contextValue = useAccessRestrictedByIp();
  const container = getContainer();

  container.bindContextValue(AccessRestrictedByIpContextSymbol, contextValue, true);

  return (
    <AccessRestrictedByIpContext.Provider value={ contextValue }>
      { children }
    </AccessRestrictedByIpContext.Provider>
  );
};

export default AccessRestrictedByIpContextProvider;
